import React, { Component } from 'react';
import { Button, Col, Row } from 'antd';
import './homepage.css';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginRequest, b2cPolicies } from '../../../../authConfig';
import LogoUpload from '../../../../components/LogoUpload';

export default class Homepage extends Component {
  render() {
    // const { instance, inProgress } = useMsal();
    // let activeAccount;

    // if (instance) {
    //   activeAccount = instance.getActiveAccount();
    // }

    const autoRedirect = () => {
      if (window.location.hash.endsWith('page-1')) {
        this.props.nextPage();
      } else if (localStorage.getItem('registerToSaveSkipToPage1')) {
        localStorage.removeItem('registerToSaveSkipToPage1');
        setTimeout(() => {
          this.props.nextPage();
        }, 1000)
      }
    };
    autoRedirect();

    const handleLoginRedirect = () => {
      window.instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };
    const cleanLocalStorageForGuest = () => {
      localStorage.removeItem('quiz-step1-page1')
      localStorage.removeItem('quiz-step2-page1')
      localStorage.removeItem('reset')
      localStorage.removeItem('selected-workplace-hazard')
      localStorage.removeItem('loginToken')
      localStorage.removeItem('logoUrl');
    }
    const cleanLocalStorageForLoggedInUser = () => {
      localStorage.removeItem('quiz-step1-page1')
      localStorage.removeItem('quiz-step2-page1')
      localStorage.removeItem('reset')
      localStorage.removeItem('selected-workplace-hazard')
    }
    const handleContinueAsGuest = () => {
      cleanLocalStorageForGuest()
      this.props.nextPage()
    }
    const handleStartHandbook = () => {
      cleanLocalStorageForLoggedInUser()
      this.props.nextPage()
    }
    return (
      <>
        <div className="quiz-intro-container">
          <div className="quiz-intro">
            <div className="quiz-intro-title-container">
              <div className="quiz-intro-title-wrapper">
                <div className="quiz-intro-title">
                  Health & Safety Orientation Handbook Generator
                </div>
                <div className="quiz-intro-title-text">
                  Helping your small business quickly produce an employee health and safety handbook that adds value to your orientation training
                </div>
                <div className="background-logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="301"
                    height="236"
                    viewBox="0 0 301 236"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M85.5973 200.175L46.3075 161.323L85.1405 122.048C94.6732 112.395 107.441 106.612 120.984 105.812C128.658 105.812 132.06 112.905 134.974 122.622L139.236 137.809C139.519 138.832 139.851 139.813 140.21 140.787L140.331 141.15L140.331 141.155C140.331 141.157 140.331 141.159 140.331 141.16C140.331 141.165 140.333 141.165 140.338 141.165C146.589 157.571 163.894 165.929 180.443 159.662C180.923 159.479 181.39 159.262 181.853 159.047L181.854 159.046C181.984 158.986 182.114 158.925 182.244 158.866C170.553 160.164 159.504 152.761 156.034 140.383L149.002 115.287L173.044 105.62C184.418 101.388 196.442 106.061 202.429 116.28C202.396 116.142 202.364 116.006 202.332 115.87L202.332 115.869C202.212 115.351 202.094 114.845 201.927 114.325C197.208 99.0098 183.275 90.1273 168.696 91.7845L168.567 91.7769C165.343 91.7769 165.574 89.3496 165.94 88.002C172.036 71.9735 185.445 58.9876 203.278 54.2576L256.671 40.0561L268.09 82.9964C269.193 87.1413 265.255 89.3157 258.54 88.6437L253.119 87.6207H253.085C252.866 87.5495 252.639 87.5051 252.409 87.4886L245.894 86.2655C228.299 82.9246 211.194 95.1518 207.502 113.876C207.4 114.361 207.339 114.846 207.277 115.326L207.277 115.327C207.255 115.505 207.232 115.681 207.208 115.857C212.134 104.733 223.614 98.0283 235.358 100.286L260.461 105.114L255.841 131.988C253.613 144.891 243.327 154.713 231.519 155.366C231.695 155.413 231.868 155.462 232.041 155.51C232.496 155.637 232.945 155.763 233.421 155.853C236.842 156.555 240.36 156.649 243.814 156.133C243.806 156.138 243.8 156.142 243.795 156.146C243.785 156.154 243.776 156.161 243.757 156.17C243.919 156.133 244.074 156.095 244.236 156.068C245.282 155.898 246.316 155.676 247.351 155.411C247.424 155.39 247.495 155.374 247.565 155.358C247.647 155.339 247.728 155.321 247.815 155.294C285.663 145.238 308.196 106.382 298.128 68.5458L279.898 0L211.368 18.2255C178.148 27.0514 156.733 58.0099 158.786 91.0559L158.767 91.0408C158.767 91.0408 159.228 94.359 155.574 95.8275L145.902 99.7195C145.902 99.7195 140.195 102.218 134.721 98.9909C134.434 98.8128 134.135 98.6551 133.826 98.519C106.835 84.0156 72.4718 88.2549 49.8409 111.15L0 161.58L50.4411 211.432C78.3079 238.985 123.188 238.755 150.746 210.858C151.39 210.196 151.99 209.508 152.587 208.822C152.876 208.492 153.164 208.161 153.456 207.834C132.271 220.93 104.102 218.446 85.5973 200.175ZM243.402 162.011L243.402 162.011C243.09 161.951 242.779 161.892 242.466 161.829C264.297 173.886 275.901 200.047 268.985 225.698L254.278 280.14L200.938 265.742C175.811 258.944 159.579 235.497 160.402 210.062C160.286 210.416 160.167 210.769 160.049 211.121L160.047 211.126C159.719 212.099 159.392 213.072 159.115 214.093C148.685 252.692 170.893 292.254 208.688 302.473L277.165 320.951L296.04 251.047C306.474 212.444 284.289 172.901 246.452 162.686C245.439 162.402 244.424 162.208 243.402 162.011ZM185.524 211.179C171.648 199.092 170.896 178.367 183.497 164.868C183.861 164.47 184.243 164.113 184.629 163.75C184.716 163.669 184.803 163.587 184.89 163.505C179.145 173.569 180.942 186.359 190.137 194.256L209.948 211.266L227.698 191.557C235.931 182.414 236.249 169.424 229.405 160.285C229.558 160.398 229.712 160.508 229.866 160.619C230.218 160.872 230.571 161.125 230.915 161.406C245.04 173.01 246.652 193.735 234.199 207.729L211.217 233.512L185.524 211.179Z"
                      fill="#004A7E"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="quiz-intro-body-container">
              <div className="quiz-intro-body-wrapper">
                <div className="quiz-intro-body-title">
                  Develop your handbook in three simple steps
                </div>
                <div className="quiz-intro-body-steps-container">
                  <div className="quiz-intro-body-steps-wrapper">
                    <div className="quiz-intro-body-step">
                      <div>1</div>
                      <div>Provide your company details</div>
                    </div>
                    <div className="quiz-intro-body-step-space">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="CaretRight">
                          <path
                            id="Vector"
                            d="M17.2959 12.7959L9.79593 20.2959C9.58458 20.5072 9.29794 20.626 8.99905 20.626C8.70017 20.626 8.41352 20.5072 8.20218 20.2959C7.99083 20.0846 7.8721 19.7979 7.8721 19.499C7.8721 19.2001 7.99083 18.9135 8.20218 18.7021L14.9062 12L8.20405 5.2959C8.09941 5.19125 8.01639 5.06702 7.95976 4.93029C7.90313 4.79356 7.87398 4.64702 7.87398 4.49902C7.87398 4.35103 7.90313 4.20448 7.95976 4.06776C8.01639 3.93103 8.09941 3.80679 8.20405 3.70215C8.3087 3.5975 8.43293 3.51449 8.56966 3.45785C8.70639 3.40122 8.85293 3.37207 9.00093 3.37207C9.14892 3.37207 9.29547 3.40122 9.43219 3.45785C9.56892 3.51449 9.69316 3.5975 9.7978 3.70215L17.2978 11.2021C17.4026 11.3068 17.4856 11.4311 17.5423 11.5679C17.5989 11.7047 17.6279 11.8513 17.6278 11.9994C17.6276 12.1475 17.5982 12.2941 17.5412 12.4307C17.4843 12.5674 17.4009 12.6915 17.2959 12.7959Z"
                            fill="#4A4845"
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="quiz-intro-body-step">
                      <div>2</div>
                      <div>Save your handbook</div>
                    </div>
                    <div className="quiz-intro-body-step-space">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="CaretRight">
                          <path
                            id="Vector"
                            d="M17.2959 12.7959L9.79593 20.2959C9.58458 20.5072 9.29794 20.626 8.99905 20.626C8.70017 20.626 8.41352 20.5072 8.20218 20.2959C7.99083 20.0846 7.8721 19.7979 7.8721 19.499C7.8721 19.2001 7.99083 18.9135 8.20218 18.7021L14.9062 12L8.20405 5.2959C8.09941 5.19125 8.01639 5.06702 7.95976 4.93029C7.90313 4.79356 7.87398 4.64702 7.87398 4.49902C7.87398 4.35103 7.90313 4.20448 7.95976 4.06776C8.01639 3.93103 8.09941 3.80679 8.20405 3.70215C8.3087 3.5975 8.43293 3.51449 8.56966 3.45785C8.70639 3.40122 8.85293 3.37207 9.00093 3.37207C9.14892 3.37207 9.29547 3.40122 9.43219 3.45785C9.56892 3.51449 9.69316 3.5975 9.7978 3.70215L17.2978 11.2021C17.4026 11.3068 17.4856 11.4311 17.5423 11.5679C17.5989 11.7047 17.6279 11.8513 17.6278 11.9994C17.6276 12.1475 17.5982 12.2941 17.5412 12.4307C17.4843 12.5674 17.4009 12.6915 17.2959 12.7959Z"
                            fill="#4A4845"
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="quiz-intro-body-step">
                      <div>3</div>
                      <div>Review and Download</div>
                    </div>
                  </div>
                </div>
                <div className="quiz-intro-body-subtitle">
                  <AuthenticatedTemplate>
                    Because you're signed in enjoy the following benefits:
                  </AuthenticatedTemplate>
                  <UnauthenticatedTemplate>
                    Sign up with your business email address to:
                  </UnauthenticatedTemplate>
                </div>
                <div className="quiz-intro-body-checkbox-container">
                  <ul>
                    <li>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="Check">
                          <path
                            id="Vector"
                            d="M21.796 7.54597L9.79596 19.546C9.69144 19.6509 9.56725 19.7341 9.4305 19.7909C9.29376 19.8476 9.14715 19.8769 8.99908 19.8769C8.85102 19.8769 8.70441 19.8476 8.56766 19.7909C8.43092 19.7341 8.30672 19.6509 8.20221 19.546L2.95221 14.296C2.84756 14.1913 2.76455 14.0671 2.70792 13.9304C2.65128 13.7936 2.62213 13.6471 2.62213 13.4991C2.62213 13.3511 2.65128 13.2046 2.70792 13.0678C2.76455 12.9311 2.84756 12.8069 2.95221 12.7022C3.05685 12.5976 3.18109 12.5146 3.31782 12.4579C3.45455 12.4013 3.60109 12.3721 3.74908 12.3721C3.89708 12.3721 4.04362 12.4013 4.18035 12.4579C4.31708 12.5146 4.44131 12.5976 4.54596 12.7022L9.00002 17.1563L20.2041 5.9541C20.4154 5.74276 20.7021 5.62402 21.001 5.62402C21.2998 5.62402 21.5865 5.74276 21.7978 5.9541C22.0092 6.16544 22.1279 6.45209 22.1279 6.75098C22.1279 7.04986 22.0092 7.33651 21.7978 7.54785L21.796 7.54597Z"
                            fill="#558F26"
                          />
                        </g>
                      </svg>
                      <div>
                        Save your handbook
                      </div>
                    </li>
                    <li>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="Check">
                          <path
                            id="Vector"
                            d="M21.796 7.54597L9.79596 19.546C9.69144 19.6509 9.56725 19.7341 9.4305 19.7909C9.29376 19.8476 9.14715 19.8769 8.99908 19.8769C8.85102 19.8769 8.70441 19.8476 8.56766 19.7909C8.43092 19.7341 8.30672 19.6509 8.20221 19.546L2.95221 14.296C2.84756 14.1913 2.76455 14.0671 2.70792 13.9304C2.65128 13.7936 2.62213 13.6471 2.62213 13.4991C2.62213 13.3511 2.65128 13.2046 2.70792 13.0678C2.76455 12.9311 2.84756 12.8069 2.95221 12.7022C3.05685 12.5976 3.18109 12.5146 3.31782 12.4579C3.45455 12.4013 3.60109 12.3721 3.74908 12.3721C3.89708 12.3721 4.04362 12.4013 4.18035 12.4579C4.31708 12.5146 4.44131 12.5976 4.54596 12.7022L9.00002 17.1563L20.2041 5.9541C20.4154 5.74276 20.7021 5.62402 21.001 5.62402C21.2998 5.62402 21.5865 5.74276 21.7978 5.9541C22.0092 6.16544 22.1279 6.45209 22.1279 6.75098C22.1279 7.04986 22.0092 7.33651 21.7978 7.54785L21.796 7.54597Z"
                            fill="#558F26"
                          />
                        </g>
                      </svg>
                      <div>
                        Create multiple handbooks
                      </div>
                    </li>
                    <li>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="Check">
                          <path
                            id="Vector"
                            d="M21.796 7.54597L9.79596 19.546C9.69144 19.6509 9.56725 19.7341 9.4305 19.7909C9.29376 19.8476 9.14715 19.8769 8.99908 19.8769C8.85102 19.8769 8.70441 19.8476 8.56766 19.7909C8.43092 19.7341 8.30672 19.6509 8.20221 19.546L2.95221 14.296C2.84756 14.1913 2.76455 14.0671 2.70792 13.9304C2.65128 13.7936 2.62213 13.6471 2.62213 13.4991C2.62213 13.3511 2.65128 13.2046 2.70792 13.0678C2.76455 12.9311 2.84756 12.8069 2.95221 12.7022C3.05685 12.5976 3.18109 12.5146 3.31782 12.4579C3.45455 12.4013 3.60109 12.3721 3.74908 12.3721C3.89708 12.3721 4.04362 12.4013 4.18035 12.4579C4.31708 12.5146 4.44131 12.5976 4.54596 12.7022L9.00002 17.1563L20.2041 5.9541C20.4154 5.74276 20.7021 5.62402 21.001 5.62402C21.2998 5.62402 21.5865 5.74276 21.7978 5.9541C22.0092 6.16544 22.1279 6.45209 22.1279 6.75098C22.1279 7.04986 22.0092 7.33651 21.7978 7.54785L21.796 7.54597Z"
                            fill="#558F26"
                          />
                        </g>
                      </svg>
                      <div>
                        Return later to edit the handbook
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="quiz-auth-buttons-container">
                  <AuthenticatedTemplate>
                    <Button className="quiz-auth-button quiz-auth-button-guest" onClick={() => handleStartHandbook()}>
                      {'Start Handbook'}
                    </Button>
                  </AuthenticatedTemplate>
                  <UnauthenticatedTemplate>
                    <Button className="quiz-auth-button quiz-auth-button-register" onClick={handleLoginRedirect}>
                      {'Register an account'}
                    </Button>
                    <Button className="quiz-auth-button quiz-auth-button-guest" onClick={() => handleContinueAsGuest()}>
                      {'Continue as Guest'}
                    </Button>
                  </UnauthenticatedTemplate>
                </div>
                <div className="quiz-intro-spacer"></div>
                <div className="quiz-intro-req">
                  The Employee Health & Safety Handbook is not exhaustive in its coverage of health
                  and safety responsibilities and requirements. For additional information regarding
                  health and safety legal requirements:
                  <div>
                    <ul>
                      <li>
                        Review the Occupational Health and Safety Act and any Regulations that apply
                        to your workplace
                      </li>
                      <li>
                        Review the Road Map Health & Safety Checklist, located in
                        the <a target="_blank" href="https://www.wsps.ca/how-we-help/small-business-centre">WSPS Small Business Centre</a>
                      </li>
                      <li>
                        View the <a target="_blank" href="https://www.wsps.ca/about-us/policies/wsps-website-privacy-policy">WSPS Website Privacy Policy</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
